// 节能建议相关API接口
import request from '@/utils/request'

/**
 * 创建并推送节能建议
 * @param data
 * @returns {*}
 */
export function addSuggest(data) {
    return request({
        url: '/suggests/saveAndPush',
        method: 'post',
        data
    })
}

/**
 * 获取某个项目的节能建议
 * @param params
 * @param pid
 * @returns {*}
 */
export function suggestPage(params,pid) {
    return request({
        url:'/suggests/pageByPid/'+pid,
        method: 'get',
        params
    })
}
